@if (initialized) {
  @if (!account.hasPicture) {
    <div class="profile-char">
      {{account.profileChar}}
    </div>
  }
  @if (account.hasPicture) {
    <div class="profile-pic">
      <img [src]="account.picture?.thumb_url" alt="{{account.name}} profile picture" />
    </div>
  }
  <div class="mat-caption">{{account.first_name}} {{account.lastnameChar}}</div>
}
